<template>
  <div class="shujuzhongxinSheng">
    <BaseDrawer direction="rtl" :ShowClose="true">
      <div class="wrap">
        <Title />
        <div class="jcxx">
          <Collapse
            title="基础信息"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="jcxxIsShow"
          >
            <Tag
              v-for="(item, index) in fuwqixunijijcxx"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </Collapse>
        </div>
        <div class="ztxx">
          <Collapse
            title="状态信息"
            :iconUrl="require('../../../assets/img/SSGJ/ztxxIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="ztxxIsShow"
          >
            <Tag
              v-for="(item, index) in fuwqixunijiztxx"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </Collapse>
        </div>
        <div class="czzl">
          <Collapse
            title="操作指令"
            :iconUrl="require('../../../assets/img/SSGJ/czzlIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="czzlIsShow"
          >
            <TagButton
              v-for="(item, index) in fuwqixunijiczzl"
              :key="index"
              @runInHole="runInHole"
              :text="item"
              :iconUrl="btnimg[index]"
            />
          </Collapse>
        </div>
        <!-- <div class="ckll">
          <Collapse
            title="查看链路"
            :iconUrl="require('../../../assets/img/SSGJ/ckll.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="ckllIsShow"
          >
            <TagButton
              @runInHole="runInHole"
              :text="'G2 7914AC10-02'"
              :iconUrl="require('../../../assets/img/SSGJ/ckll.png')"
            />
          </Collapse>
        </div> -->
        <div class="gjxx">
          <Collapse
            title="告警信息"
            :iconUrl="require('../../../assets/img/SSGJ/gjxxIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="gjxxIsShow"
          >
            <Table
              :CData="fuwqixunijigjxx"
              :NavData="['时间 ', '告警级别', '内容 ']"
              :NavWidth="['278px', '128px', '200px']"
            />
          </Collapse>
        </div>
      </div>
    </BaseDrawer>
  </div>
</template>

<script>
import Collapse from '@/components/common/communal/Collapse'
import Pagination from '@/components/common/communal/Pagination'
import Table from '@//components/common/communal/Table'
import Tag from '@/components/common/communal/Tag'
import TagButton from '@/components/common/communal/TagButton'
import BaseDrawer from '@/components/common/BaseDrawer'
import Title from '@/components/common/communal/Title'
import ChartLineArea from '@/components/charts/ChartLineArea'
export default {
  components: {
    Collapse,
    Pagination,
    Table,
    Tag,
    TagButton,
    Title,
    BaseDrawer,
    ChartLineArea,
  },
  data() {
    return {
      fuwqixunijijcxx: [
        {
          name: '编号',
          value: 'G2 7914AC10-01',
        },
        {
          name: '所属',
          value: 'SJZX-01-JF',
        },
        {
          name: '品牌',
          value: 'IBM',
        },
        {
          name: '型号',
          value: 'SQL数据库服务器',
        },
        {
          name: 'U高',
          value: '3',
        },
      ],
      fuwqixunijiztxx: [
        {
          name: 'CPU负载',
          value: '11%',
        },
        {
          name: 'GPU负载',
          value: '23%',
        },
        {
          name: '内存已占用空间',
          value: '23GB',
        },
        {
          name: '内存负载',
          value: '31%',
        },
        {
          name: '硬盘已占用空间',
          value: '500GB',
        },
      ],
      fuwqixunijiczzl: ['显示虚拟机', '设备正面', '设备反面'],
      fuwqixunijigjxx: [
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '服务器连接异常',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '服务器连接异常',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: 'CPU使用率过高',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: 'GPU使用率过高',
        },
        { time: '2022-07-11 12:00:00', content: '三级', second: '路由器-03连' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
      ],
      btnimg: [
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
        require('../../../assets/img/SSGJ/sbIcon.png'),
      ],
      jcxxIsShow: true,
      ztxxIsShow: true,
      czzlIsShow: true,
      ckllIsShow: true,
      gjxxIsShow: false,
      isOpen: false,
    }
  },
  methods: {
    runInHole(p) {
      if (p == '显示虚拟机') {
        this.isOpen = true
        this.fuwqixunijiczzl = ['隐藏虚拟机', '设备正面', '设备反面']
        UEapi.Model.playAnimation({
          id: 'C03-004-04_SM_数据服务器_虚拟机',
          name: '隐藏_虚拟机机箱',
          state: 'begin',
        })
      }
      if (p == '隐藏虚拟机') {
        this.isOpen = false
        this.fuwqixunijiczzl = ['显示虚拟机', '设备正面', '设备反面']
        UEapi.Model.playAnimation({
          id: 'C03-004-04_SM_数据服务器_虚拟机',
          name: '显示_虚拟机机箱',
          state: 'begin',
        })
      }
      this.$emit('runInHole', p)
    },
    isReceiveFair(p) {
      let head = document.querySelectorAll('.Collapse_head')
      for (let index = 0; index < head.length; index++) {
        const element = head[index]
      }
      switch (p) {
        case '基础信息':
          this.jcxxIsShow = !this.jcxxIsShow
          break
        case '状态信息':
          this.ztxxIsShow = !this.ztxxIsShow
          break
        case '操作指令':
          this.czzlIsShow = !this.czzlIsShow
          break
        case '查看链路':
          this.ckllIsShow = !this.ckllIsShow
          break
        case '告警信息':
          this.gjxxIsShow = !this.gjxxIsShow
          break
        case '历史数据':
          this.lssjIsShow = !this.lssjIsShow
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 680px;
  height: 1720px;
  background: url('../../../assets/img/WLTS/left.png') no-repeat;
  overflow-y: auto;
  overflow-x: hidden;
  .czzl {
    /deep/ .Collapse {
      .Collapse_main {
        .TagButton:nth-child(1) {
          .TagButton_image {
          }
        }
      }
    }
  }
  .ztxx {
    /deep/ .Collapse {
      .Collapse_main {
        .Tag:nth-child(1) {
          .Tag_right {
          }
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 0px;
  border-radius: 0px;
  background: rgba(17, 63, 89, 0.65);
}
::-webkit-scrollbar-thumb {
  width: 0px;
  border-radius: 0px;
  background: rgba(255, 255, 255, 0.15);
  min-height: 00px;
}
</style>